// extracted by mini-css-extract-plugin
export default {"container":"wV-z","darkBackground":"xV-z","whiteBackground":"yV-z","headerButton":"zV-z","calloutHeading":"AV-z","calloutSubHeading":"BV-z"};